<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-4">
                <input class="form-control pull-right" type="search" placeholder="Search Notifications" id="example-search-input" v-model="searchQueryNotifications">
              </div>
            </div>
            <br/>
            <data-table :data="notifications" :columns="gridColumnsNotifications" :filter-key="searchQueryNotifications"></data-table>
          </div>
         </div>
       </div><!-- /.col-md-12 -->
      </div>
      <!--<div class="row">
        <div class="col-md-12 col-sm-8">
          <div class="card card-default widget animated">
            <div class="card-heading">
              <div class="row">
                <div class="col-md-4">
                  <input class="form-control pull-right" type="search" placeholder="Search Triggers" id="example-search-input" v-model="searchQueryTriggers">
                </div>
                <div class="col-md-2">
                  <router-link class="btn btn-success" to="/operations/alertsnotifications/createtrigger">Add</router-link>
                </div>
              </div>
              <br/>
              <data-table :data="triggers" :columns="gridColumnsTriggers" :filter-key="searchQueryTriggers"></data-table>
            </div>
          </div>
        </div>
      </div>/.col-md-12 -->
    </div>
    </div>
  </div>
</template>

<script>
import DataTable from './TriggersTable'
import DataTable2 from './NotificationsTable'
import database from '../../webmaster/Database/database'
import auth from '../../webmaster/Authentication/auth'
const user = auth.getUser()

export default {
  name: 'users',
  components: {
    'data-table': DataTable
  },
  data () {
    return {
      user,
      searchQueryNotifications: '',
      gridColumnsNotifications: ['title', 'type', 'datetime', 'more'],
      notifications: [],
    }
  },
  created:function(){
    this.fetchNotifications()
    this.fetchTriggers()    
  },
  methods:{
    fetchNotifications:function(){
      var ref = '/users/' + this.user.uid + '/notifications'
      this.$bindAsArray('notifications', database.getRef(ref));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// AlertsNotifications.vue?960e0b3a